import { Deserializable } from '../protocols/deserializable';
import { SubmissionStatusIdEnum } from '../enum/shared/submission-status-id.enum';
import { BaseType } from '../base/base-type';

export class MemberSubmissionStatus extends BaseType implements Deserializable {
  public declare id: SubmissionStatusIdEnum;

  onDeserialize() {}
}
